var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSketchreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.36363 3.59588L12 3L17.6363 3.59588L22 9.45366L12 21.0985L2 9.45366L6.36363 3.59588Z",
    fill: "#FDB300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05049 9.45364L12 21.0985L2 9.45364H6.05049Z",
    fill: "#EA6C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9495 9.45364L12 21.0985L22 9.45364H17.9495Z",
    fill: "#EA6C00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05049 9.45364H17.9495L12 21.0985L6.05049 9.45364Z",
    fill: "#FDAD00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3L6.36361 3.59587L6.05049 9.45366L12 3Z",
    fill: "#FDD231"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 3L17.6363 3.59587L17.9494 9.45366L11.9999 3Z",
    fill: "#FDD231"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22 9.45363L17.6363 3.59584L17.9495 9.45363H22Z",
    fill: "#FDAD00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.45363L6.36361 3.59584L6.05049 9.45363H2Z",
    fill: "#FDAD00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3L6.05049 9.45366H17.9495L12 3Z",
    fill: "#FEEEB7"
  })));
}
export default SvgSketchreact;